<template>
  <v-card color="grey lighten-5" flat>


    <v-flex xs12 sm12>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title class="white--text">Cari Kart Bilgileri</v-toolbar-title>
        <v-spacer></v-spacer>

        <a target="_self" v-bind:href="'#/cari/duzenle/'+Current.Code">
          <v-btn class="white--text" flat> <span class="hidden-sm-and-down"> Güncelle </span>
            <v-icon right dark>create</v-icon>

          </v-btn>

        </a>
      </v-toolbar>
    </v-flex>

    <v-container fluid>
      <v-layout row wrap>


        <v-flex pa-1 xs12 sm12 md6>
          <v-flex xs12 sm12 md12 style="padding-right:2px;">
            <v-card color="#1E88E5" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md1>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">perm_identity</v-icon>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm10 md11>

                  <v-card-title primary-title="">

                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              Ünvan
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md10>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              : {{ Current.Title }}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              Kod
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md10>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              : {{Current.Code}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">Yetkili</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md10>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">:
                                {{Current.Authorized}} </div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>


                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">T.C</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md10>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">:
                                {{Current.Invoice.IdentityNumber}} </div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>


                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md2>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">Vergi D./No</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md10>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">:
                                {{Current.Invoice.TaxOffice}}/{{Current.Invoice.TaxNumber}} </div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>


                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                Genel Bilgiler
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-flex>


        <v-flex pa-1 xs12 sm12 md6>
          <v-flex xs12 sm12 md12 style="padding-right:2px;">
            <v-card color="#1E88E5" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md1>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">info</v-icon>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm10 md11>

                  <v-card-title primary-title="">

                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md1>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              Tel 1
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md11>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              : {{ Current.Phone1 }}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md1>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              Tel 2
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md11>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              : {{Current.Phone2}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md1>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">Web</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md11>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">:
                                {{Current.Web}} </div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md1>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">Adres</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md11>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">:
                                {{Current.Invoice.Address}} </div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>


                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md1>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1"></div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md11>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">
                              </div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                İletişim Bilgileri
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-flex>


      </v-layout>
    </v-container>

    <v-container fluid>

      <v-card color="grey lighten-5" flat="">
        <v-layout row wrap>
          <v-flex xs12 sm4 md2>

            <tarihim :etiket="'Başlangıç Tarihi'" :detaygizle="false" v-model="date" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
          </v-flex>

          <v-flex xs12 sm4 md2>
            <tarihim :etiket="'Bitiş Tarihi'" :detaygizle="false" v-model="date2" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
          </v-flex>

          <v-flex align-end="" xs12 sm1 md1>
            <div v-if="load1">

              <v-btn color="info" @click="Raporla()" fab small="" dark>
                <v-icon>search</v-icon>
              </v-btn>
            </div>
            <div v-if="!load1">
              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
            </div>
          </v-flex>

        </v-layout>

        <v-layout row="" wrap>

          <v-flex pa-1 xs12 sm6 md4>
            <v-card color="#1E88E5" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md2>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">add_comment</v-icon>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm10 md10>
                  <v-card-title primary-title="">
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md12>
                          <v-list-tile-title>
                            <span class="subheading font-weight-">
                              {{Toplambiletadet}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>

                      </v-layout>
                    </v-flex>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                <span class="subheading font-weight-bold"> Toplam Bilet Adet</span>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md4 pa-1>
            <v-card color="#4CAF50" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md2>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">receipt</v-icon>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm10 md10>
                  <v-card-title primary-title="">
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md12>
                          <v-list-tile-title>
                            <span class="subheading font-weight-">
                              {{Toplamfatbiletad}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                <span class="subheading font-weight-bold">Fatura Edilmiş Bilet Adet</span>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md4 pa-1>
            <v-card color="#FF5252
" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md2>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">receipt</v-icon>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm10 md10>

                  <v-card-title primary-title="">

                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md12>
                          <v-list-tile-title>
                            <span class="subheading font-weight-">
                              {{Faturaedilmemisbilet}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>

                      </v-layout>
                    </v-flex>


                  </v-card-title>

                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                <span class="subheading font-weight-bold"> Fatura Edilmemiş Bilet Adet</span>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>



        </v-layout>

        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>



      </v-card>
    </v-container>
  </v-card>




</template>


<script>
  import auth from '../../../api/auth'
    import tarihim from "@/components/app/customcomp/tarihim.vue"
  import helpers from "@/components/app/customcomp/helpers.js"

  export default {
    data() {
      return {
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        modal2: false,
        dateFormatted2: '',
        Current: {
          CompanyCode: '',
          Code: '',
          Title: '',
          Phone1: '',
          Phone2: '',
          Mobile: '',
          Web: '',
          Authorized: '',
          WarningNote: '',
          InfoNote: '',
          Invoice: {
            Address: '',
            PostCode: '',
            Province: '',
            Country: '',
            TaxNumber: '',
            TaxOffice: '',
            IdentityNumber: ''
          }
        },
        StartDate: null,
        EndDate: null,
        Faturaedilmemisbilet: 0,
        Toplamfatbiletad: 0,
        Toplambiletadet: 0,
        load: false,
        load1: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',

        dictionary: {
          custom: {

            tarihsecbas: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsecbit: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },

      }
    },
    methods: {

      Raporla: Raporla,
    },
    beforeMount: beforeMount,
      components: {
      tarihim
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
  }






  function beforeMount() {

    this.load = true
    this.load1 = false

   // this.date = helpers.getDateNow();
   // this.date2 =helpers.getDateNow();

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var getCurrentInput = {
      Code: this.$route.params.id,
      CompanyCode: credentials.SirketKodu,
      SummaryInfoShow: true
    }
    this.$http.post(auth.API_URL + 'api/Current/Get', getCurrentInput, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.Toplambiletadet = response.body.SummaryInfo.SalesNumber
      this.Faturaedilmemisbilet = response.body.SummaryInfo.NoInvoiceTicketNumber
      this.Toplamfatbiletad = response.body.SummaryInfo.InvoiceTicketNumber
      this.Current = response.body

      this.load = false
      this.load1 = true

    }, (response) => {
      if (response.status === 0) {
        this.load = false
        this.load1 = true
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.load = false
        this.load1 = true
      }
    })
  }



  function Raporla() {

    this.load1 = false

    this.$validator.validateAll().then((result) => {

      if (result) {

        var bastarih = new Date(this.date)
        var bittarih = new Date(this.date2)

        if (bastarih <= bittarih) {

          var credentials1 = JSON.parse(window.localStorage.getItem('credentials'));



          var params = {
            SirketKodu: credentials1.SirketKodu,
            BaslangicTarihi: new Date(this.date),
            BitisTarihi: new Date(this.date2),
            CariKod: this.Current.Code
          }

          this.$http.post(auth.API_URL + 'api/TicketReport/SummaryInfoList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.load1 = true

            this.Toplambiletadet = response.body.SatisAdet
            this.Faturaedilmemisbilet = response.body.FaturalanmamisBiletAdet
            this.Toplamfatbiletad = response.body.FaturalanmisBiletAdet

          }, (response) => {
            this.load1 = true

            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.load1 = true

              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        } else {
          this.load1 = true

          this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
          this.snackbar = true
        }
      }
    })
  }
</script>

<style>

</style>